// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18" width="10" height="18">
            <path
                fill="currentColor"
                d="m2.169 17.618 7.488-7.774a1.21 1.21 0 0 0 0-1.687L2.169.383A1.278 1.278 0 0 0 .393.335a1.207 1.207 0 0 0-.049 1.736l6.719 6.93-6.719 6.93a1.207 1.207 0 0 0 .05 1.735 1.28 1.28 0 0 0 1.775-.048Z"
            />
        </svg>
    );
};

export default React.memo(ChevronRight);
